import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';


@Injectable()
export class FaqService {
  constructor(private httpClient: HttpClient) { }

  catList(): Observable<any> {
    return this.httpClient.get<any>('faq/category');
  }

  list(cat): Observable<any> {
    return this.httpClient.get<any>('faq/'+cat);
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/services/faq/faq.service.ts